import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type FetchVacationData} from './fetch-vacation';

export function fetchVacationTypePatcher(data: FetchVacationData): RestTypeWithTypename<FetchVacationData> {
    return {
        ...data,
        __typename: 'FetchVacation',
        vacation: {...data.vacation, __typename: 'Vacation'},
        allReplies: data.allReplies.map(reply => ({...reply, __typename: 'AllReply'})),
        ownReplies: data.ownReplies.map(reply => ({...reply, __typename: 'OwnReply'})),
        openingHours: data.openingHours.map(reply => ({...reply, __typename: 'OpeningHour'})),
        allowedHours: data.allowedHours.map(reply => ({...reply, __typename: 'AllowedHour'})),
    };
}
